import React, { useState } from 'react';
import PropTypes from 'prop-types';

const TermsStep = ({ termsConditions, onAccept, onBack, loading }) => {
  const [accepted, setAccepted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (accepted) {
      onAccept();
    }
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  return (
    <div className="space-y-4">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">Terms & Conditions</h3>
        <p className="text-sm text-gray-600">
          Please read and accept the terms & conditions for {termsConditions?.program?.title}
        </p>
      </div>

      <div className="max-h-64 overflow-y-auto border border-gray-200 rounded-lg p-4 bg-gray-50">
        <h4 className="font-semibold text-gray-900 mb-3">{termsConditions?.title}</h4>
        <div 
          className="prose prose-sm max-w-none text-gray-700"
          dangerouslySetInnerHTML={createMarkup(termsConditions?.content || '')}
        />
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="flex items-start space-x-3">
          <input
            type="checkbox"
            id="acceptTerms"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            className="mt-1 h-4 w-4 text-[#1086a4] focus:ring-[#1086a4] border-gray-300 rounded"
          />
          <label htmlFor="acceptTerms" className="text-sm text-gray-700">
            I have read and accept the terms and conditions
          </label>
        </div>

        <div className="flex space-x-3">
          <button
            type="button"
            onClick={onBack}
            className="flex-1 py-3 px-4 bg-gray-300 hover:bg-gray-400 text-gray-700 font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors duration-200 shadow-sm"
          >
            Back
          </button>
          <button
            type="submit"
            disabled={!accepted || loading}
            className="flex-1 py-3 px-4 bg-[#1086a4] hover:bg-[#0c6d85] disabled:bg-gray-400 text-white font-semibold rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1086a4] focus:ring-offset-2 transition-colors duration-200 shadow-sm"
          >
            {loading ? 'Loading...' : 'Accept & Continue'}
          </button>
        </div>
      </form>
    </div>
  );
};

TermsStep.propTypes = {
  termsConditions: PropTypes.object,
  onAccept: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default TermsStep;